<template>
  <v-layout pl-2 pt-2 pr-2 pb-2 row>
    <v-flex xs4 lg2>
      <SimpleCard>
        <ExportAccountTripsBox :exportSettings="exportSettings"></ExportAccountTripsBox>
      </SimpleCard>
    </v-flex>
    <!-- <v-flex xs8 lg10 pl-2>
      <SimpleCard>
        <v-layout row wrap align-content-center justify-center>
          <v-flex py-2 xs9 class="text-xs-center pt-2">
            <v-pagination @input="changePage" v-model="pagination.page" :length="num_pages"></v-pagination>
          </v-flex>
          <v-flex v-if="loading" xs12 pa-2 class="text-xs-center">
            <v-progress-circular :size="48" :width="5" color="primary" indeterminate></v-progress-circular>
          </v-flex>
          <InvoicePolicyList
            v-if="!loading"
            style="width: 100%;"
            :invoicePolicyList="invoicePolicies"
            :paginationProp="pagination"
            @select="editInvoicePolicy"
          ></InvoicePolicyList>
          <v-flex v-if="!loading" pt-2 xs9 class="text-xs-center pt-2">
            <v-pagination @input="changePage" v-model="pagination.page" :length="num_pages"></v-pagination>
          </v-flex>
        </v-layout>
      </SimpleCard>
    </v-flex>-->
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import ExportAccountTripsBox from "@/components/account_invoice_policy/ExportAccountTripsBox.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import moment from "moment";

export default {
  name: "export_account_trips",
  components: {
    SimpleCard,
    ExportAccountTripsBox
  },
  data: function() {
    var now = new Date();

    var startDate = moment(now, "YYYY-MM-DD")
      .subtract(1, "month")
      .startOf("day")
      .toDate()
      .toISOString()
      .substr(0, 10);

    var endDate = moment(now, "YYYY-MM-DD")
      .startOf("day")
      .toDate()
      .toISOString()
      .substr(0, 10);

    return {
      dialog: false,
      invoicePolicies: [],
      offset: 0,
      count: 20,
      query: {
        enabledOnly: false
      },
      loading: true,
      pagination: { page: 1 },
      num_pages: 0,
      exportSettings: {
        start_date: startDate,
        end_date: endDate,
        user: {},
        account_customers_only: false,
        include_cancelled: false
      }
    };
  },
  mounted: async function() {
    // this.get();
  },
  methods: {}
};
</script>
